<!-- 个人电站列表（客服运维）：待审批 + 我审批 两个独立列表 -->
<template>
  <div class="personal-stations">
    <v-card class="ps-frame rounded-xl pa-4 d-flex flex-column" variant="flat">
      <!-- Tab 切换：待审批 / 我审批 -->
      <div class="ps-tabs-row d-flex align-center ga-2 mb-4 flex-shrink-0">
        <v-btn icon="mdi-arrow-left" rounded="circle" variant="flat" size="small" @click="router.back()"></v-btn>
        <v-tabs v-model="activeTab" color="#2655f1" class="ps-tabs flex-grow-1">
          <v-tab value="toApprove">待审批的电站</v-tab>
          <v-tab value="myApprove">我审批的电站</v-tab>
        </v-tabs>
      </div>

      <v-window v-model="activeTab" class="ps-window flex-grow-1 min-h-0">
        <v-window-item value="toApprove" class="ps-window-item">
          <!-- ============ 待审批的电站：所有「审批中」的电站（不分审批人） ============ -->
          <div class="toolbar-top mb-4 flex-shrink-0">
            <div class="toolbar-main d-flex flex-wrap align-center ga-4">
              <div class="search-item">
                <span class="search-label">电站名称</span>
                <v-text-field v-model="toApproveKwInput" placeholder="请输入电站名称" variant="outlined" density="compact"
                  hide-details clearable rounded="xl" prepend-inner-icon="mdi-magnify" class="search-input"
                  @keyup.enter="searchToApprove" @click:clear="searchToApprove" />
              </div>
              <div class="search-actions d-flex ga-3 ml-auto">
                <v-btn color="primary" rounded="xl" class="action-btn" @click="searchToApprove">
                  <v-icon start icon="mdi-magnify" />查询
                </v-btn>
                <v-btn variant="outlined" color="success" rounded="xl" class="action-btn" @click="resetToApprove">
                  <v-icon start icon="mdi-refresh" />重置
                </v-btn>
              </div>
            </div>
          </div>

          <div class="table-wrap">
            <div v-if="toApproveList.length" class="ps-table-host">
              <v-table fixed-header height="100%" class="gm-table ps-table gm-border rounded-lg" density="comfortable">
                <thead>
                  <tr>
                    <th style="min-width: 200px">电站名称</th>
                    <th style="min-width: 160px">型号 / 容量</th>
                    <th style="min-width: 160px">区域 / 地址</th>
                    <th style="min-width: 90px">申请者</th>
                    <th style="min-width: 90px">审批人</th>
                    <th style="min-width: 120px">审批状态</th>
                    <th style="min-width: 170px">创建时间</th>
                    <th style="min-width: 170px">审批 / 驳回时间</th>
                    <th style="min-width: 110px" class="text-center">配置进度</th>
                    <th style="width: 280px; min-width: 280px" class="text-center sticky-action-col">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in toApproveList" :key="item.stationId">
                    <tr class="ps-table-row">
                      <!-- 名称 + ID -->
                      <td>
                        <div class="cell-name" :title="item.name">{{ item.name }}</div>
                        <div class="text-caption text-medium-emphasis">ID：{{ item.stationId }}</div>
                      </td>

                      <!-- 型号 + 容量 -->
                      <td>
                        <div class="ps-text" :title="item.model">{{ item.model }}</div>
                        <div class="ps-sub ps-link-color">{{ item.capacity }}</div>
                      </td>

                      <!-- 区域 + 地址 -->
                      <td>
                        <div class="ps-text">{{ item.region }}</div>
                        <div class="ps-sub ps-link-color" :title="item.address">{{ item.address }}</div>
                      </td>

                      <!-- 申请者 -->
                      <td>{{ item.applicantName || '--' }}</td>

                      <!-- 审批人 -->
                      <td>{{ item.approverName || '--' }}</td>

                      <!-- 审批状态 -->
                      <td>
                        <div v-if="item.approveStatus" class="ps-status">
                          <v-chip :color="displayStatus(item).color" variant="tonal" size="small" label
                            class="ps-status-chip">{{ displayStatus(item).text }}</v-chip>
                          <v-menu v-if="item.approveStatus === 'rejected'" :close-on-content-click="false"
                            location="bottom" offset="6">
                            <template #activator="{ props }">
                              <button type="button" class="ps-status-icon-btn" v-bind="props"
                                :style="{ color: displayStatus(item).color }" title="查看驳回留言" @click.stop>
                                <svg class="ps-status-icon" viewBox="0 0 16 16" width="14" height="14"
                                  aria-hidden="true">
                                  <path fill="currentColor"
                                    d="M3 2.5h10A1.5 1.5 0 0 1 14.5 4v6A1.5 1.5 0 0 1 13 11.5H6.8L4 13.8V11.5H3A1.5 1.5 0 0 1 1.5 10V4A1.5 1.5 0 0 1 3 2.5Z" />
                                  <path fill="#fff" d="M5 5.4h6v1H5zM5 7.4h4v1H5z" />
                                </svg>
                              </button>
                            </template>
                            <div class="ps-reject-pop" @click.stop>
                              <div class="ps-reject-pop-title">驳回留言</div>
                              <template v-if="item.rejectMessages && item.rejectMessages.length">
                                <div v-for="(msg, mi) in item.rejectMessages" :key="mi" class="ps-reject-msg">
                                  <div class="ps-reject-msg-head">
                                    <span class="ps-reject-approver">{{ msg.approver }}</span>
                                    <span class="ps-reject-time">{{ msg.time }}</span>
                                  </div>
                                  <div class="ps-reject-content">{{ msg.content }}</div>
                                </div>
                              </template>
                              <div v-else class="ps-reject-empty">暂无留言</div>
                            </div>
                          </v-menu>
                        </div>
                        <span v-else>--</span>
                      </td>

                      <!-- 创建时间 -->
                      <td class="ps-muted">{{ item.createTime || '—' }}</td>

                      <!-- 审批/驳回时间 -->
                      <td class="ps-muted">{{ item.approveTime || '--' }}</td>

                      <!-- 配置进度 -->
                      <td class="text-center">
                        <div class="ps-progress-cell">
                          <span class="ps-pie" :title="`已配置 ${configuredCount(item)}/${item.steps.length}`">
                            <svg viewBox="0 0 24 24" width="22" height="22">
                              <circle cx="12" cy="12" r="11" :fill="pieTrackColor(item)" />
                              <path v-if="pieMode(item) === 'arc'" :d="piePath(configuredRatio(item))"
                                :fill="PROGRESS_GREEN" />
                              <path v-if="pieMode(item) === 'check'" d="M7.2 12.2l3 3 6-6.4" fill="none" stroke="#fff"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <g v-else-if="pieMode(item) === 'dots'" fill="#fff">
                                <circle cx="8" cy="12" r="1.3" />
                                <circle cx="12" cy="12" r="1.3" />
                                <circle cx="16" cy="12" r="1.3" />
                              </g>
                            </svg>
                          </span>
                          <span class="ps-progress-text">{{ configuredCount(item) }}/{{ item.steps.length }}</span>
                        </div>
                      </td>

                      <!-- 操作 -->
                      <td class="text-center sticky-action-col">
                        <div class="action-buttons justify-center">
                          <v-menu :close-on-content-click="false" location="bottom" offset="6"
                            @update:modelValue="(open) => onApproveRecordMenu(open, item)">
                            <template #activator="{ props }">
                              <v-btn variant="text" color="#2655f1" rounded="xl" density="comfortable"
                                v-bind="props">审批记录</v-btn>
                            </template>
                            <ApproveRecordTimeline :records="getApproveRecords(item)"
                              :loading="isApproveRecordsLoading(item)" />
                          </v-menu>
                          <v-btn variant="text" color="#2655f1" rounded="xl" density="comfortable"
                            @click="handleEdit(item)">审批</v-btn>
                          <v-btn variant="text" color="#2655f1" rounded="xl" density="comfortable"
                            @click="toggleExpand(toApproveExpandedIds, item.stationId)">
                            {{ toApproveExpandedIds.includes(item.stationId) ? '收起' : '配置' }}
                            <v-icon end size="18"
                              :icon="toApproveExpandedIds.includes(item.stationId) ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                          </v-btn>
                        </div>
                      </td>
                    </tr>

                    <!-- 展开行：建站配置流程 -->
                    <tr v-if="toApproveExpandedIds.includes(item.stationId)" class="ps-expand-row">
                      <td :colspan="10" class="ps-expand-cell">
                        <div class="ps-steps">
                          <template v-for="(step, index) in item.steps" :key="step.label">
                            <span v-if="index > 0" class="ps-step-line"
                              :style="{ background: step.configured ? PROGRESS_GREEN : PROGRESS_PINK }" />
                            <div class="ps-step">
                              <span class="ps-step-dot"
                                :style="{ background: step.configured ? PROGRESS_GREEN : PROGRESS_PINK }">{{ index + 1
                                }}</span>
                              <span class="ps-step-label">{{ step.label }}</span>
                              <span class="ps-step-state">{{ step.configured ? '已配置' : '未配置' }}</span>
                            </div>
                          </template>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </v-table>
            </div>
            <div v-else class="empty-tip text-center py-10 text-medium-emphasis">
              暂无符合条件的电站
            </div>
          </div>

          <TablePagination v-if="toApproveTotal > 0" v-model="toApprovePageNum" v-model:pageSize="toApprovePageSize"
            :total="toApproveTotal" hasSizes hasJump color="#2655f1" class="ps-pagination flex-shrink-0" />
        </v-window-item>

        <v-window-item value="myApprove" class="ps-window-item">
          <!-- ============ 我审批的电站：我「审批通过」或「我已驳回」的电站 ============ -->
          <div class="toolbar-top mb-4 flex-shrink-0">
            <div class="toolbar-main d-flex flex-wrap align-center ga-4">
              <div class="search-item">
                <span class="search-label">电站名称</span>
                <v-text-field v-model="myApproveKwInput" placeholder="请输入电站名称" variant="outlined" density="compact"
                  hide-details clearable rounded="xl" prepend-inner-icon="mdi-magnify" class="search-input"
                  @keyup.enter="searchMyApprove" @click:clear="searchMyApprove" />
              </div>
              <div class="search-item">
                <span class="search-label">审批状态</span>
                <v-select v-model="myApproveFilter" :items="MY_APPROVE_STATUS_ITEMS" item-title="title"
                  item-value="value" placeholder="全部状态" variant="outlined" density="compact" hide-details clearable
                  rounded="xl" class="search-input--select" />
              </div>
              <div class="search-actions d-flex ga-3 ml-auto">
                <v-btn color="primary" rounded="xl" class="action-btn" @click="searchMyApprove">
                  <v-icon start icon="mdi-magnify" />查询
                </v-btn>
                <v-btn variant="outlined" color="success" rounded="xl" class="action-btn" @click="resetMyApprove">
                  <v-icon start icon="mdi-refresh" />重置
                </v-btn>
              </div>
            </div>
          </div>

          <div class="table-wrap">
            <div v-if="myApproveList.length" class="ps-table-host">
              <v-table fixed-header height="100%" class="gm-table ps-table gm-border rounded-lg" density="comfortable">
                <thead>
                  <tr>
                    <th style="min-width: 200px">电站名称</th>
                    <th style="min-width: 160px">型号 / 容量</th>
                    <th style="min-width: 160px">区域 / 地址</th>
                    <th style="min-width: 90px">申请者</th>
                    <th style="min-width: 90px">审批人</th>
                    <th style="min-width: 120px">审批状态</th>
                    <th style="min-width: 170px">创建时间</th>
                    <th style="min-width: 170px">审批 / 驳回时间</th>
                    <th style="min-width: 110px" class="text-center">配置进度</th>
                    <th style="width: 280px; min-width: 280px" class="text-center sticky-action-col">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in myApproveList" :key="item.stationId">
                    <tr class="ps-table-row">
                      <!-- 名称 + ID -->
                      <td>
                        <div class="cell-name" :title="item.name">{{ item.name }}</div>
                        <div class="text-caption text-medium-emphasis">ID：{{ item.stationId }}</div>
                      </td>

                      <!-- 型号 + 容量 -->
                      <td>
                        <div class="ps-text" :title="item.model">{{ item.model }}</div>
                        <div class="ps-sub ps-link-color">{{ item.capacity }}</div>
                      </td>

                      <!-- 区域 + 地址 -->
                      <td>
                        <div class="ps-text">{{ item.region }}</div>
                        <div class="ps-sub ps-link-color" :title="item.address">{{ item.address }}</div>
                      </td>

                      <!-- 申请者 -->
                      <td>{{ item.applicantName || '--' }}</td>

                      <!-- 审批人 -->
                      <td>{{ item.approverName || '--' }}</td>

                      <!-- 审批状态 -->
                      <td>
                        <div v-if="item.approveStatus" class="ps-status">
                          <v-chip :color="displayStatus(item).color" variant="tonal" size="small" label
                            class="ps-status-chip">{{ displayStatus(item).text }}</v-chip>
                          <v-menu v-if="item.approveStatus === 'rejected'" :close-on-content-click="false"
                            location="bottom" offset="6">
                            <template #activator="{ props }">
                              <button type="button" class="ps-status-icon-btn" v-bind="props"
                                :style="{ color: displayStatus(item).color }" title="查看驳回留言" @click.stop>
                                <svg class="ps-status-icon" viewBox="0 0 16 16" width="14" height="14"
                                  aria-hidden="true">
                                  <path fill="currentColor"
                                    d="M3 2.5h10A1.5 1.5 0 0 1 14.5 4v6A1.5 1.5 0 0 1 13 11.5H6.8L4 13.8V11.5H3A1.5 1.5 0 0 1 1.5 10V4A1.5 1.5 0 0 1 3 2.5Z" />
                                  <path fill="#fff" d="M5 5.4h6v1H5zM5 7.4h4v1H5z" />
                                </svg>
                              </button>
                            </template>
                            <div class="ps-reject-pop" @click.stop>
                              <div class="ps-reject-pop-title">驳回留言</div>
                              <template v-if="item.rejectMessages && item.rejectMessages.length">
                                <div v-for="(msg, mi) in item.rejectMessages" :key="mi" class="ps-reject-msg">
                                  <div class="ps-reject-msg-head">
                                    <span class="ps-reject-approver">{{ msg.approver }}</span>
                                    <span class="ps-reject-time">{{ msg.time }}</span>
                                  </div>
                                  <div class="ps-reject-content">{{ msg.content }}</div>
                                </div>
                              </template>
                              <div v-else class="ps-reject-empty">暂无留言</div>
                            </div>
                          </v-menu>
                        </div>
                        <span v-else>--</span>
                      </td>

                      <!-- 创建时间 -->
                      <td class="ps-muted">{{ item.createTime || '—' }}</td>

                      <!-- 审批/驳回时间 -->
                      <td class="ps-muted">{{ item.approveTime || '--' }}</td>

                      <!-- 配置进度 -->
                      <td class="text-center">
                        <div class="ps-progress-cell">
                          <span class="ps-pie" :title="`已配置 ${configuredCount(item)}/${item.steps.length}`">
                            <svg viewBox="0 0 24 24" width="22" height="22">
                              <circle cx="12" cy="12" r="11" :fill="pieTrackColor(item)" />
                              <path v-if="pieMode(item) === 'arc'" :d="piePath(configuredRatio(item))"
                                :fill="PROGRESS_GREEN" />
                              <path v-if="pieMode(item) === 'check'" d="M7.2 12.2l3 3 6-6.4" fill="none" stroke="#fff"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <g v-else-if="pieMode(item) === 'dots'" fill="#fff">
                                <circle cx="8" cy="12" r="1.3" />
                                <circle cx="12" cy="12" r="1.3" />
                                <circle cx="16" cy="12" r="1.3" />
                              </g>
                            </svg>
                          </span>
                          <span class="ps-progress-text">{{ configuredCount(item) }}/{{ item.steps.length }}</span>
                        </div>
                      </td>

                      <!-- 操作 -->
                      <td class="text-center sticky-action-col">
                        <div class="action-buttons justify-center">
                          <v-menu :close-on-content-click="false" location="bottom" offset="6"
                            @update:modelValue="(open) => onApproveRecordMenu(open, item)">
                            <template #activator="{ props }">
                              <v-btn variant="text" color="#2655f1" rounded="xl" density="comfortable"
                                v-bind="props">审批记录</v-btn>
                            </template>
                            <ApproveRecordTimeline :records="getApproveRecords(item)"
                              :loading="isApproveRecordsLoading(item)" />
                          </v-menu>
                          <v-btn variant="text" color="#2655f1" rounded="xl" density="comfortable"
                            @click="handleEdit(item)">详情</v-btn>
                          <v-btn variant="text" color="#2655f1" rounded="xl" density="comfortable"
                            @click="toggleExpand(myApproveExpandedIds, item.stationId)">
                            {{ myApproveExpandedIds.includes(item.stationId) ? '收起' : '配置' }}
                            <v-icon end size="18"
                              :icon="myApproveExpandedIds.includes(item.stationId) ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
                          </v-btn>
                        </div>
                      </td>
                    </tr>

                    <!-- 展开行：建站配置流程 -->
                    <tr v-if="myApproveExpandedIds.includes(item.stationId)" class="ps-expand-row">
                      <td :colspan="10" class="ps-expand-cell">
                        <div class="ps-steps">
                          <template v-for="(step, index) in item.steps" :key="step.label">
                            <span v-if="index > 0" class="ps-step-line"
                              :style="{ background: step.configured ? PROGRESS_GREEN : PROGRESS_PINK }" />
                            <div class="ps-step">
                              <span class="ps-step-dot"
                                :style="{ background: step.configured ? PROGRESS_GREEN : PROGRESS_PINK }">{{ index + 1
                                }}</span>
                              <span class="ps-step-label">{{ step.label }}</span>
                              <span class="ps-step-state">{{ step.configured ? '已配置' : '未配置' }}</span>
                            </div>
                          </template>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </v-table>
            </div>
            <div v-else class="empty-tip text-center py-10 text-medium-emphasis">
              暂无符合条件的电站
            </div>
          </div>

          <TablePagination v-if="myApproveTotal > 0" v-model="myApprovePageNum" v-model:pageSize="myApprovePageSize"
            :total="myApproveTotal" hasSizes hasJump color="#2655f1" class="ps-pagination flex-shrink-0" />
        </v-window-item>
      </v-window>
    </v-card>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import dayjs from 'dayjs'
import TablePagination from '@/components/TablePagination/index.vue'
import ApproveRecordTimeline from './ApproveRecordTimeline.vue'
import {
  getTodoStationApprovalList,
  getApprovedStationApprovalList,
  getStationApprovalList,
} from '@/api/device/station'

const route = useRoute()
const router = useRouter()

/** 当前选中的 Tab：待审批 / 我审批（初始值取 URL query.tab） */
const TAB_VALUES = ['toApprove', 'myApprove']
const activeTab = ref(TAB_VALUES.includes(route.query.tab) ? route.query.tab : 'toApprove')

/** 进度色板：绿=已配置/已完成，粉=未配置 */
const PROGRESS_GREEN = '#1FC76B'
const PROGRESS_PINK = '#F0397B'

/** 我审批列表：审批状态枚举（「审批通过」/「已驳回」） */
const MY_APPROVE_STATUS_ITEMS = [
  { title: '审批通过', value: 'approved' },
  { title: '已驳回', value: 'rejected' },
]

/** 状态码 ↔ UI key（接口 status：0待审批 1通过 2驳回） */
const STATUS_CODE_TO_KEY = { 0: 'pending', 1: 'approved', 2: 'rejected' }
const STATUS_KEY_TO_CODE = { pending: 0, approved: 1, rejected: 2 }

const fmtTime = (v) => {
  if (!v) return ''
  const d = dayjs(v)
  return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : String(v)
}

/**
 * 卡片状态文字派生规则
 */
const displayStatus = (item) => {
  if (item.approveStatus === 'pending') return { text: '审批中', color: '#1FC76B' }
  if (item.approveStatus === 'rejected') return { text: '已驳回', color: '#FF8A1E' }
  if (item.approveStatus === 'approved') return { text: '审批通过', color: '#2655f1' }
  return { text: '--', color: '#909399' }
}

/** 建站流程（3 步：基本信息 / 电站设备 / 电站拓扑），根据接口 configStep 计算已配置数量
 *  configStep 即已配置步数：1→已配基础 / 2→已配基础+设备 / 3→三步全配 / 4→完成态
 */
const STEP_LABELS = ['基本信息', '电站设备', '电站拓扑']
const buildSteps = (configStep) => {
  const done = Math.min(STEP_LABELS.length, Math.max(0, configStep || 0))
  return STEP_LABELS.map((label, i) => ({ label, configured: i < done }))
}

/** 地址：省 + 市 + 区县 拼接（空字段自动跳过） */
const composeAddress = (row) =>
  [row.province, row.city, row.district].filter(Boolean).join('') || '—'

/** 容量 / 功率展示：接口 capacity 单位 kWh、maxPower 单位 kW，拼成 "xx kW / xx kWh" */
const composeCapacity = (row) => {
  const power = row.maxPower ? `${row.maxPower}kW` : ''
  const cap = row.capacity ? `${row.capacity}kWh` : ''
  if (power && cap) return `${power}/${cap}`
  return power || cap || '—'
}

/** 由「电站建站审核列表」多条记录构造时间线（按 applyTime 升序，逐条展开为 submit + 结果） */
const buildApproveRecordsFromList = (rows = []) => {
  const list = []
  const sorted = [...rows].sort((a, b) => {
    const ta = new Date(a.applyTime || a.createTime || 0).getTime()
    const tb = new Date(b.applyTime || b.createTime || 0).getTime()
    return ta - tb
  })
  for (const row of sorted) {
    if (row.applyTime || row.applicantName) {
      list.push({
        action: 'submit',
        operator: row.applicantName || row.applicantAccount || '—',
        time: fmtTime(row.applyTime),
        comment: '提交建站审批申请',
      })
    }
    if (row.status === 1 && (row.approveTime || row.approverName)) {
      list.push({
        action: 'approve',
        operator: row.approverName || row.approverAccount || '—',
        time: fmtTime(row.approveTime),
        comment: row.approveRemark || '审核通过',
      })
    } else if (row.status === 2 && (row.approveTime || row.approverName)) {
      list.push({
        action: 'reject',
        operator: row.approverName || row.approverAccount || '—',
        time: fmtTime(row.approveTime),
        comment: row.approveRemark || '',
      })
    }
  }
  return list
}

/** 接口行 → 页面展示行 */
const mapRow = (row) => {
  const approveStatus = STATUS_CODE_TO_KEY[row.status]
  return {
    id: row.id,
    name: row.stationName || '—',
    stationId: row.stationId ?? row.bizId ?? '—',
    model: row.productModel || '—',
    capacity: composeCapacity(row),
    region: row.area || '—',
    address: composeAddress(row),
    owner: row.approverName || row.applicantName || '--',
    applicantName: row.applicantName || '',
    approverName: row.approverName || '',
    approveStatus,
    createTime: fmtTime(row.createTime),
    approveTime: fmtTime(row.approveTime),
    steps: buildSteps(row.configStep),
    configStep: row.configStep,
    rejectMessages:
      approveStatus === 'rejected' && row.approveRemark
        ? [{ approver: row.approverName || '—', time: fmtTime(row.approveTime), content: row.approveRemark }]
        : [],
    _raw: row,
  }
}

/* ============ 待审批的电站：调用 /device/v3/station/approval/todo/list ============ */
const toApproveList = ref([])
const toApproveTotal = ref(0)
const toApproveKwInput = ref('') // 输入框实时值
const toApproveKeyword = ref('') // 点击查询后生效的关键词
const toApprovePageNum = ref(1)
const toApprovePageSize = ref(10)
const toApproveExpandedIds = ref([])
const toApproveLoading = ref(false)

const fetchToApprove = async () => {
  toApproveLoading.value = true
  try {
    const params = {
      pageNum: toApprovePageNum.value,
      pageSize: toApprovePageSize.value,
    }
    const kw = toApproveKeyword.value?.trim()
    if (kw) params.stationName = kw
    const res = await getTodoStationApprovalList(params)
    const rows = res?.rows || res?.data?.rows || []
    toApproveList.value = rows.map(mapRow)
    toApproveTotal.value = res?.total ?? res?.data?.total ?? 0
  } catch (e) {
    console.error('获取待审批的电站列表失败', e)
    toApproveList.value = []
    toApproveTotal.value = 0
  } finally {
    toApproveLoading.value = false
  }
}

watch(toApprovePageNum, () => fetchToApprove())
watch(toApprovePageSize, () => {
  toApprovePageNum.value = 1
  fetchToApprove()
})

const searchToApprove = () => {
  toApproveKeyword.value = toApproveKwInput.value?.trim() || ''
  toApprovePageNum.value = 1
  fetchToApprove()
}

const resetToApprove = () => {
  toApproveKwInput.value = ''
  toApproveKeyword.value = ''
  toApprovePageNum.value = 1
  fetchToApprove()
}

/* ============ 我审批的电站：调用 /device/v3/station/approval/approved/list ============ */
const myApproveList = ref([])
const myApproveTotal = ref(0)
const myApproveKwInput = ref('') // 输入框实时值
const myApproveKeyword = ref('') // 点击查询后生效的关键词
const myApproveFilter = ref(null) // 审批状态筛选（approved / rejected / null）
const myApprovePageNum = ref(1)
const myApprovePageSize = ref(10)
const myApproveExpandedIds = ref([])
const myApproveLoading = ref(false)

const fetchMyApprove = async () => {
  myApproveLoading.value = true
  try {
    const params = {
      pageNum: myApprovePageNum.value,
      pageSize: myApprovePageSize.value,
    }
    const kw = myApproveKeyword.value?.trim()
    if (kw) params.stationName = kw
    if (myApproveFilter.value != null) {
      params.status = STATUS_KEY_TO_CODE[myApproveFilter.value]
    }
    const res = await getApprovedStationApprovalList(params)
    const rows = res?.rows || res?.data?.rows || []
    myApproveList.value = rows.map(mapRow)
    myApproveTotal.value = res?.total ?? res?.data?.total ?? 0
  } catch (e) {
    console.error('获取我审批的电站列表失败', e)
    myApproveList.value = []
    myApproveTotal.value = 0
  } finally {
    myApproveLoading.value = false
  }
}

watch(myApprovePageNum, () => fetchMyApprove())
watch(myApprovePageSize, () => {
  myApprovePageNum.value = 1
  fetchMyApprove()
})

const searchMyApprove = () => {
  myApproveKeyword.value = myApproveKwInput.value?.trim() || ''
  myApprovePageNum.value = 1
  fetchMyApprove()
}

const resetMyApprove = () => {
  myApproveFilter.value = null
  myApproveKwInput.value = ''
  myApproveKeyword.value = ''
  myApprovePageNum.value = 1
  fetchMyApprove()
}

/** 切换 Tab：同步到 URL query，并按需拉取对应列表 */
watch(
  activeTab,
  (tab) => {
    if (route.query.tab !== tab) {
      router.replace({ query: { ...route.query, tab } })
    }
    if (tab === 'toApprove') fetchToApprove()
    else if (tab === 'myApprove') fetchMyApprove()
  },
  { immediate: true }
)

/* ============ 审批记录懒加载（按 stationId 缓存，两个 Tab 共用一份缓存） ============ */
const approveRecordsMap = ref({}) // { [stationId]: TimelineRecord[] }
const approveRecordsLoadingMap = ref({}) // { [stationId]: boolean }

const loadApproveRecords = async (item) => {
  const key = item.stationId
  if (!key || key === '—') return
  if (approveRecordsMap.value[key] || approveRecordsLoadingMap.value[key]) return
  approveRecordsLoadingMap.value = { ...approveRecordsLoadingMap.value, [key]: true }
  try {
    const res = await getStationApprovalList({
      stationId: key,
      pageNum: 1,
      pageSize: 50,
    })
    const rows = res?.rows || []
    approveRecordsMap.value = {
      ...approveRecordsMap.value,
      [key]: buildApproveRecordsFromList(rows),
    }
  } catch (e) {
    console.error('获取审批记录失败', e)
    approveRecordsMap.value = { ...approveRecordsMap.value, [key]: [] }
  } finally {
    const next = { ...approveRecordsLoadingMap.value }
    delete next[key]
    approveRecordsLoadingMap.value = next
  }
}

const getApproveRecords = (item) => approveRecordsMap.value[item.stationId] || []
const isApproveRecordsLoading = (item) => !!approveRecordsLoadingMap.value[item.stationId]

const onApproveRecordMenu = (open, item) => {
  if (open) loadApproveRecords(item)
}

/* ============ 公共方法 ============ */

/** 展开/收起（按列表各自的展开集合操作） */
const toggleExpand = (expandedIds, id) => {
  const idx = expandedIds.indexOf(id)
  if (idx > -1) expandedIds.splice(idx, 1)
  else expandedIds.push(id)
}

const configuredCount = (item) => item.steps.filter((s) => s.configured).length
const configuredRatio = (item) => configuredCount(item) / item.steps.length

/**
 * 进度环形态：
 * 已驳回 → 省略号；已投运 → 对勾；其余 → 配置进度扇形
 */
const pieMode = (item) => {
  if (item.approveStatus === 'rejected') return 'dots'
  if (item.approveStatus === 'approved') return 'check'
  return 'arc'
}
const pieTrackColor = (item) => (pieMode(item) === 'arc' ? '#E9EBF0' : PROGRESS_GREEN)

/** 生成扇形 path（从 12 点方向顺时针填充） */
const piePath = (fraction, r = 11, cx = 12, cy = 12) => {
  if (fraction <= 0) return ''
  if (fraction >= 1) {
    return `M ${cx} ${cy - r} A ${r} ${r} 0 1 1 ${cx - 0.01} ${cy - r} Z`
  }
  const angle = fraction * 2 * Math.PI
  const x = cx + r * Math.sin(angle)
  const y = cy - r * Math.cos(angle)
  const large = fraction > 0.5 ? 1 : 0
  return `M ${cx} ${cy} L ${cx} ${cy - r} A ${r} ${r} 0 ${large} 1 ${x} ${y} Z`
}

/** 详情跳转：审批人视角，默认落到「基本信息」步骤，保留驳回 / 投运操作 */
const handleEdit = (item) => {
  router.push({
    path: '/approve',
    query: {
      stationId: item.stationId,
      step: 'basic',
    },
  })
}
</script>

<style scoped lang="scss">
.personal-stations {
  display: flex;
  flex-direction: column;
  width: calc(100vw - var(--sidebar-width, 154px));
  max-width: calc(100vw - var(--sidebar-width, 154px));
  height: calc(100vh - var(--header-height, 70px));
  min-width: 0;
  box-sizing: border-box;
  padding: clamp(8px, 1.2vw, 20px);
  font-family: 'HarmonyOS Sans SC', 'PingFang SC', sans-serif;
  overflow: hidden;
}

.ps-frame {
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

/* Tab 切换 */
.ps-tabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.ps-tabs :deep(.v-tab) {
  font-size: 16px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}

.ps-window {
  display: flex;
  flex-direction: column;
}

.ps-window {
  min-width: 0;
  width: 100%;
}

.ps-window :deep(.v-window__container),
.ps-window :deep(.v-window-item) {
  height: 100%;
  min-width: 0;
  width: 100%;
}

.ps-window-item {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  width: 100%;
  height: 100%;
}

/* 工具栏 */
.toolbar-top {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.toolbar-main {
  min-width: 0;
}

.action-btn {
  text-transform: none;
  letter-spacing: 0;
  white-space: nowrap;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  .search-label {
    flex-shrink: 0;
    white-space: nowrap;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
    text-align: right;
    min-width: 64px;
  }

  .search-input {
    width: 220px;
  }

  .search-input--select {
    width: 180px;
  }
}

.search-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
  row-gap: 12px;
}

/* 表格容器 */
.table-wrap {
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ps-table-host {
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ps-table {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 0;
  min-height: 0;
}

.ps-table :deep(.v-table__wrapper) {
  overflow: auto;
}

.ps-table :deep(.v-table__wrapper > table) {
  width: 100%;
  min-width: max-content;
  table-layout: fixed;
}

.ps-table :deep(thead th) {
  background: rgba(255, 255, 255, 0.96) !important;
  font-weight: 600 !important;
  color: rgba(0, 0, 0, 0.8) !important;
  white-space: nowrap;
}

.ps-table :deep(tbody td) {
  vertical-align: middle;
  color: #2e2e2e;
}

.ps-table :deep(.ps-table-row:hover)>td {
  background: rgba(38, 85, 241, 0.03);
}

/* 展开行 */
.ps-expand-cell {
  padding: 16px 16px !important;
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

/* 操作列固定在右侧 */
.ps-table :deep(th.sticky-action-col),
.ps-table :deep(td.sticky-action-col) {
  position: sticky;
  right: 0;
  white-space: nowrap;
  box-sizing: border-box;
  border-left: 1px solid var(--color-td-border, rgba(0, 0, 0, 0.08));
  box-shadow: -8px 0 14px -10px rgba(0, 0, 0, 0.18);
}

.ps-table :deep(th.sticky-action-col) {
  z-index: 4;
  background-color: #fff !important;
}

.ps-table :deep(td.sticky-action-col) {
  z-index: 1;
  background-color: #fff;
}

.ps-table :deep(tbody tr:hover td.sticky-action-col) {
  background-color: #fff;
  background-image: linear-gradient(90deg, rgba(38, 85, 241, 0.06) 0%, rgba(85, 7, 253, 0.06) 100%);
}

/* 操作按钮组 */
.action-buttons {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.action-buttons :deep(.v-btn) {
  min-width: auto;
  padding-inline: 8px;
  white-space: nowrap;
}

/* 单元格文本 */
.cell-name {
  max-width: 280px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ps-text {
  font-size: 14px;
  color: #2e2e2e;
  line-height: 1.5;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ps-sub {
  font-size: 13px;
  line-height: 1.5;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ps-muted {
  color: rgba(46, 46, 46, 0.5);
}

.ps-link-color {
  color: #2655f1;
}

/* 审批状态 */
.ps-status {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ps-status-chip {
  height: 24px !important;
  font-size: 12px;
  font-weight: 500;
}

.ps-status-icon {
  flex-shrink: 0;
}

.ps-status-icon-btn {
  display: inline-flex;
  align-items: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: inherit;
  line-height: 0;
}

/* 驳回留言弹层 */
.ps-reject-pop {
  min-width: 240px;
  max-width: 340px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  padding: 14px 16px;
}

.ps-reject-pop-title {
  font-size: 14px;
  font-weight: 600;
  color: #2e2e2e;
  margin-bottom: 10px;
}

.ps-reject-msg+.ps-reject-msg {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.ps-reject-msg-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}

.ps-reject-approver {
  font-size: 13px;
  font-weight: 500;
  color: #2e2e2e;
}

.ps-reject-time {
  font-size: 12px;
  color: rgba(46, 46, 46, 0.45);
}

.ps-reject-content {
  font-size: 13px;
  line-height: 1.6;
  color: rgba(46, 46, 46, 0.75);
}

.ps-reject-empty {
  font-size: 13px;
  color: rgba(46, 46, 46, 0.45);
}

/* 配置进度 */
.ps-progress-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ps-progress-text {
  font-size: 13px;
  color: rgba(46, 46, 46, 0.7);
}

.ps-pie {
  display: inline-flex;
  line-height: 0;
}

/* 展开区：建站流程 */
.ps-steps {
  display: flex;
  align-items: flex-start;
  background: #f5f6f8;
  border-radius: 12px;
  padding: 22px 40px;
}

.ps-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  text-align: center;
}

.ps-step-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.ps-step-label {
  margin-top: 10px;
  font-size: 13px;
  color: #2e2e2e;
  white-space: nowrap;
}

.ps-step-state {
  margin-top: 4px;
  font-size: 12px;
  color: rgba(46, 46, 46, 0.5);
  white-space: nowrap;
}

.ps-step-line {
  flex: 1 1 auto;
  height: 2px;
  min-width: 36px;
  margin-top: 11px;
}

/* 空态 */
.empty-tip {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(46, 46, 46, 0.45);
  font-size: 14px;
}

/* 分页 */
.ps-pagination {
  :deep(.table-pagination) {
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 1200px) {
  .ps-steps {
    padding: 18px 16px;
    overflow-x: auto;
  }
}

/* ============ 小屏 1366x768 兼容适配（对齐电站管理列表） ============ */
@media (max-width: 1440px) {
  .toolbar-main {
    gap: 12px !important;
    row-gap: 10px !important;
  }

  .search-item {
    gap: 8px;

    .search-label {
      min-width: auto;
      font-size: 13px;
    }

    .search-input {
      width: 180px;
    }

    .search-input--select {
      width: 140px;
    }
  }

  .search-actions {
    gap: 8px !important;
    row-gap: 8px !important;
  }

  .action-btn {
    padding: 0 12px !important;
    font-size: 13px !important;
    letter-spacing: 0 !important;
    min-width: 0 !important;
  }

  .ps-table :deep(th.sticky-action-col),
  .ps-table :deep(td.sticky-action-col) {
    width: 280px;
    min-width: 280px;
  }
}

@media (max-width: 1366px) {
  .toolbar-main {
    gap: 10px !important;
    row-gap: 8px !important;
  }

  .search-item {
    gap: 6px;

    .search-label {
      font-size: 12px;
    }

    .search-input {
      width: 160px;
    }

    .search-input--select {
      width: 128px;
    }
  }

  .search-actions {
    gap: 6px !important;
    row-gap: 8px !important;
  }

  .action-btn {
    padding: 0 10px !important;
    font-size: 12px !important;
    height: 32px !important;
  }

  .action-btn :deep(.v-icon) {
    font-size: 16px !important;
  }

  .ps-frame {
    padding: 12px !important;
  }

  .ps-table :deep(th.sticky-action-col),
  .ps-table :deep(td.sticky-action-col) {
    width: 280px;
    min-width: 280px;
  }

  .ps-table :deep(thead th),
  .ps-table :deep(tbody td) {
    padding-inline: 12px !important;
  }

  .cell-name {
    max-width: 220px;
  }

  .action-buttons :deep(.v-btn) {
    padding-inline: 6px !important;
    font-size: 12px !important;
  }
}

@media (max-height: 800px) {
  .toolbar-top {
    margin-bottom: 12px !important;
  }

  .ps-pagination {
    :deep(.table-pagination) {
      padding-top: 8px;
      padding-bottom: 4px;
    }
  }
}
</style>
